import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RetrieveThemeCommand } from '../../models/identity/commands/retrieve-theme-command.model';
import { CommunityWithRoles } from '../../models/identity/community-with-roles.model';
import { AccountsService } from '../../services/identity/accounts.service';
import { ProfileService } from '../../services/identity/profile.service';
import { ThemeService } from '../../services/shared/theme.service';

@Component({
    selector: 'app-user-select-main-community',
    templateUrl: './user-select-main-community.component.html',
    styleUrls: ['./user-select-main-community.component.scss'],
})
export class UserSelectMainCommunityComponent implements OnInit, OnDestroy {
    @Input() communities: Array<CommunityWithRoles> = [];

    communitiesDialog: boolean = false;
    public selectedCommunityId: string | null = null;

    private destroy$ = new Subject<void>();

    get primaryCommunity(): CommunityWithRoles | undefined {
        return this.communities.find((c) => c.isPrimary);
    }

    get initialPrimaryCommunityId(): string | null {
        return this.primaryCommunity?.id || null;
    }

    constructor(private profileService: ProfileService, private accountsService: AccountsService, private themeService: ThemeService) {}

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    showCommunitiesDialog(): void {
        this.selectedCommunityId = this.initialPrimaryCommunityId;
        this.communitiesDialog = true;
    }

    selectCommunity(communityId: string): void {
        this.selectedCommunityId = communityId;
    }

    confirmNewPrimaryCommunity(): void {
        if (!this.selectedCommunityId) {
            return;
        }

        this.profileService
            .updateUserMainCommunity(this.selectedCommunityId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.communities = this.communities.map((c) => ({
                        ...c,
                        isPrimary: c.id === this.selectedCommunityId,
                    }));

                    const selectedCommunity = this.communities.find((c) => c.id === this.selectedCommunityId);
                    if (selectedCommunity) {
                        this.accountsService.currentUser.primaryCommunity = selectedCommunity;
                        this.accountsService.currentUser.communities = [...this.communities];
                        this.themeService
                            .retrieve({ communityId: this.selectedCommunityId } as RetrieveThemeCommand)
                            .pipe(takeUntil(this.destroy$))
                            .subscribe({
                                next: (theme) => {
                                    this.accountsService.currentUser.theme = theme;
                                    this.themeService.applyThemeToDocument(theme);
                                },
                            });
                    }

                    this.accountsService.saveCurrentUser();
                    this.accountsService.refreshCurrentUser();

                    this.communitiesDialog = false;
                },
                error: (err) => {},
            });
    }
}
